import React from "react";

import { DriverFormData } from "./AddDriverModal";

interface DriverViewModalProps {
  driver: DriverFormData;
  onClose: () => void;
  vehicles: any[];
}

const DriverViewModal: React.FC<DriverViewModalProps> = ({
  driver,
  onClose,
  vehicles,
}) => {
  const handlePrint = () => {
    window.print();
  };
  // Type guard for driver.vehicle
  function isVehicleObj(val: unknown): val is {
    brand?: string;
    id?: string;
    licensePlate?: string;
    make?: string;
    model?: string;
    plate_number?: string;
  } {
    return typeof val === "object" && val !== null;
  }

  const vehicleInfo = vehicles.find((v: any) => {
    if (!driver.vehicle) return false;
    if (isVehicleObj(driver.vehicle)) {
      return v.id === driver.vehicle.id;
    }
    return v.id === driver.vehicle;
  });
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-gray-900"
        onClick={(e) => e.stopPropagation()}
        style={{ maxHeight: "90vh", overflowY: "auto", width: "80vw" }}
      >
        <h2 className="mb-4 text-lg font-semibold text-gray-900 dark:text-gray-100">
          Driver Info
        </h2>
        <div className="space-y-2">
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Name:
            </span>{" "}
            {driver.full_name}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Email:
            </span>{" "}
            {driver.email}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Phone:
            </span>{" "}
            {driver.phone}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Address:
            </span>{" "}
            {driver.address}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              License Number:
            </span>{" "}
            {driver.licenseNumber}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              License Expiry:
            </span>{" "}
            {driver.licenseExpiry}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Status:
            </span>{" "}
            {driver.status}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Assigned Vehicle:
            </span>{" "}
            {(() => {
              if (vehicleInfo) {
                return `${vehicleInfo.year || ""} ${vehicleInfo.brand || vehicleInfo.make || ""} ${vehicleInfo.model || ""} (${vehicleInfo.plate || vehicleInfo.plate_number || vehicleInfo.licensePlate || ""})`;
              }
              if (isVehicleObj(driver.vehicle)) {
                const v = driver.vehicle;
                // Only show ID if no other info is present
                if (
                  v.brand ||
                  v.make ||
                  v.model ||
                  v.plate_number ||
                  v.licensePlate
                ) {
                  return ` ${v.brand || v.make || ""} ${v.model || ""} (${v.plate_number || v.licensePlate || ""})`;
                }
                return "No vehicle details";
              }
              // If it's a string, don't show just the ID, show 'None' or blank
              return driver.vehicle && typeof driver.vehicle === "string"
                ? "No vehicle details"
                : "None";
            })()}
          </div>
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button
            className="rounded bg-gray-200 px-4 py-2 text-gray-700 dark:bg-gray-700 dark:text-gray-200"
            onClick={onClose}
          >
            Close
          </button>
          <button
            className="rounded bg-blue-600 px-4 py-2 text-white dark:bg-blue-500"
            onClick={handlePrint}
          >
            Print
          </button>
        </div>
      </div>
    </div>
  );
};

export default DriverViewModal;
